import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    paddingBottom: 20,
    backfaceVisibility: 'visible',
    backgroundColor: 'transparent',
  },
  imageStyle: {marginTop: '60%'},
  backgroundStyles: {
    flex: 1,
    width: '100%',
    height: '100%',
  },
  containerPadding: {
    paddingHorizontal: 20,
  },
  orderNumberText: {
    textAlign: 'left',
    marginBottom: 5,
    marginTop: 20,
  },
  orderPlacedText: {
    textAlign: 'left',
    marginBottom: 20,
  },
  verticalStepperWrapper: {},
  tipHBox: {
    marginRight: 10,
  },
  dividerMargin: {
    marginVertical: 20,
  },
  customerAndDeliveryHeader: {
    textAlign: 'left',
  },
  renderDetailsContainer: {
    marginTop: 0,
  },
  renderDetailsKeyText: {
    textAlign: 'left',
    marginBottom: 2,
  },
  renderDetailsValueText: {
    textAlign: 'left',
  },
  supportStyle: {marginTop: 20},
});
